import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material';

import { FadeInAnimation } from '../shared/fade-in.animation';

@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss'],
  animations: [FadeInAnimation]
})
export class ConfirmDialogComponent implements OnInit {

  action: string;
  message: string;
  question: string;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
    this.message = this.data.message;
    this.question = this.data.question;
    this.action = this.data.action != null ? this.data.action : "Confirm";
  }

}


// WEBPACK FOOTER //
// ./src/app/shared/confirm-dialog.component.ts